// nome gerados no site https://colornamer.robertcooper.me/
const UHCDesignTokens = {
    color: {
        ghost_uh: '#0088a5',
        carbon: '#333'
    }
  };

export default UHCDesignTokens;